<template>
    <div
        class="group my-4 rounded-lg border-iron-200 bg-white px-4 py-5 shadow-sm hover:shadow-md w-full border transition-all duration-200"
    >
        <div class="space-x-3 sm:flex items-center justify-between">
            <div class="gap-2 flex items-center">
                <div class="flex-shrink-0"></div>
                <div class="min-w-0 flex-1">
                    <p class="font-medium text-iron-900">
                        <span v-if="!appearance.default">{{
                            appearance.name
                        }}</span>
                        <span
                            v-if="appearance.default"
                            class="rounded-md bg-iron-50 px-3 py-1 text-sm font-medium text-iron-600 ring-iron-500/10 inline-flex items-center ring-1 ring-inset"
                            >{{ $t("appearances.default") }}</span
                        >
                    </p>
                </div>
            </div>

            <div
                class="mt-3 sm:mt-0 flex flex-shrink-0 justify-start self-center"
            >
                <div class="rounded-md shadow-sm inline-flex">
                    <EditAppearanceModal :appearance="appearance">
                        <button
                            class="gap-2 rounded-l-md rounded-r-md bg-white px-3 py-2 text-sm font-medium text-iron-900 ring-iron-300 hover:bg-iron-50 relative -ml-px inline-flex items-center ring-1 ring-inset focus:z-10"
                        >
                            <Pencil :size="20"></Pencil>

                            <span class="sm:inline-block hidden">{{
                                $t("edit")
                            }}</span>
                        </button>
                    </EditAppearanceModal>
                    <button
                        :disabled="appearance.default"
                        :class="
                            appearance.default
                                ? 'cursor-not-allowed opacity-50'
                                : ''
                        "
                        class="ml-2 gap-2 rounded-l-md rounded-r-md bg-white px-3 py-2 text-sm font-medium text-iron-900 ring-iron-300 hover:bg-iron-50 relative inline-flex items-center ring-1 ring-inset focus:z-10"
                        @click="deleteAppearance(appearance.id)"
                    >
                        <Trash2 :size="20" />
                        <span class="sm:inline-block hidden">{{
                            $t("remove")
                        }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, PropType } from "vue";
import { IAppearance } from "@/types/IAppearance";
import { Pencil, Trash2 } from "lucide-vue-next";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import { useI18n } from "vue-i18n";
import useConfirm from "../../ConfirmDialog/composables/useConfirm";
import EditAppearanceModal from "../EditAppearanceModal.vue";

const { t } = useI18n();

const { show } = useConfirm();

defineProps({
    appearance: {
        type: Object as PropType<IAppearance>,
        required: true,
    },
});

async function deleteAppearance(id: number) {
    const confirmed = await show({
        type: "danger",
        message: t("appearances.delete.description"),
        header: t("appearances.delete.title"),
    });

    if (confirmed) {
        router.delete(route("app.appearances.delete", id));
    }
}
</script>
